import {
  StandardError,
  CommerceLayerError,
  CommerceLayerErrorAttributes,
  ApiErrorErrorBody,
} from "./api.interface"

class ApiError extends Error {
  constructor(
    private response: Response,
    private body: (CommerceLayerError & StandardError) | string | undefined
  ) {
    super()

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError)
    }
  }

  get title(): string {
    return this.response.statusText
  }

  get url(): string {
    return this.response.url
  }

  get status(): number {
    return this.response.status
  }

  get errorBody(): ApiErrorErrorBody[] | string {
    if (typeof this.body === "undefined") {
      return ""
    }

    if (typeof this.body === "string") {
      return this.body
    }

    if (typeof this.body.message === "string") {
      return this.body.message
    }

    if (this.body.errors) {
      return this.body.errors.map((err: CommerceLayerErrorAttributes) => ({
        title: err.title,
        code: err.code,
        detail: err.detail,
      }))
    }

    return ""
  }

  get message(): string {
    if (typeof this.errorBody === "string") {
      return this.errorBody
    }

    return this.errorBody
      .map((error: ApiErrorErrorBody) => error.title)
      .join(", ")
  }
}

export default ApiError
